<template>
  <div class="product-item" @click="onClick" @mouseleave="showRemark = false">
	  <div class="image-container">
	    <el-image  class="img" @mouseenter="showRemark = type == 'private' ? true : false" :src="joinHead(item.cover)"  lazy :class="{'img-down': showRemark, 'img2': type == 'winning'}"></el-image>
		  <div
		    class="remark-container"
		    :class="{'show-remark': showRemark&&type == 'private', 'remark-container2': type == 'winning'}"
		    v-if="type == 'private'"
		  >
		  
		   <!-- <div v-if="type == 'winning'" class="remark-content2">{{ item.remarkEn }}</div> -->
          <div v-if="type == 'private'" class="remark-content">
            <div class="box" style="position: absolute;right: 10px;bottom: 60px;" @click.stop="UpdateGoodsSubjectEn">
              <div class="isShow">Edit</div>
              <i class="el-icon-edit"></i>
            </div>
            <div class="box" style="position: absolute;right: 10px;bottom: 10px;" @click.stop="SelectdGoods">
              <div class="isShow">{{ this.isSelectd ? 'Back to Product Quotation' : 'Add to Selected Products' }}</div>
              <i class="el-icon-position"></i>
            </div>
          </div>
      </div>
	      <!-- <i 
	        class="el-icon-news remark-icon" 
	        v-if="item.remarkEn && !showRemark"
	        @mouseenter="showRemark = true"
	      ></i> -->
	  </div>  
	
	  
	  
	  
    <!-- <el-image class="img" :src="joinHead(item.cover)" lazy />
	
	<i class="el-icon-news"></i>
	<div>{{ item.remarkEn }}</div> -->
	
    <div class="title" @click.stop>{{ item.subjectEn }}</div>
    <div class="price" @click.stop>
      {{ currencyConver($store.getters.userInfo.currency) }}{{ item.price }}
      <span v-if="item.maxPrice != item.price"> - {{ item.maxPrice }}</span>
    </div>
    <div class="btn" :class="{'disable': item.isStore}">View Details</div>
  </div>
</template>

<script>
import { SelectdGoods, UpdateGoodsSubjectEn } from '@/api/product/goods'
export default {
	data() {
	    return {
	      showRemark: false
	    }
	  },
  props: {
	  isSelectd: {
		  type: Boolean,
		  default: false
	  },
    item: {
      type: Object,
      default() {
        return {}
      }
    },

    type: {
      validator(value) {
      // The value must match one of these strings
        return ['winning', 'private'].includes(value)
      },
      default: 'winning'
    },

    autoJump: {
      type: Boolean,
      default: true
    }
  },

  methods: {
	  async UpdateGoodsSubjectEn() {
	  	this.$prompt('Please enter the product name', 'Update Goods SubjectEn', {
	  	          confirmButtonText: 'confirm',
	  	          cancelButtonText: 'cancel',
	  	          inputPattern: /\S+/,
	  	          inputErrorMessage: 'The product name cannot be empty'
	  	        }).then(({ value }) => {
	  				UpdateGoodsSubjectEn({ SubjectEn: value, GoodsId: this.item.id }).then(() => {
	  					// this.detail.subjectEn = value
	  					this.$notify.success('success')
						this.$emit('change')
	  				})
	  	        })
	  },
	  SelectdGoods() {
		 SelectdGoods({ goodsIds: [this.item.id], isSelectd: !this.isSelectd }).then(() => {
			 this.$notify.success('success')
			 this.$emit('change')
		 })
	  },
    onClick() {
      if (this.autoJump) {
        const path = `/product/${this.type}ProductDetail/${this.item.id}`
        // console.log(path)
        this.$router.push({ path })
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>.image-container {
  position: relative;
  overflow: hidden;
}
.image-container .img {
  width: 100%;
  height: 216px;
}
.image-container .img2 {
  transition: all 0.3s ease;
}
.image-container .img2.img-down {
  transform: translateY(100%);
}
.image-container .remark-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  font-size: 24px;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  transition: all 0.3s ease;
}
.image-container .remark-icon:hover {
  color: #fff;
  transform: scale(1.1);
}
.image-container .remark-container2 {
  background: rgba(0,0,0,0.7);
  transition: all 0.3s ease;
}
.image-container .remark-container {
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  padding: 20px;
  white-space: pre-wrap;
  overflow-y: auto;
  z-index: 1;
}
.image-container .remark-container.show-remark {
  top: 0;
}
.image-container .remark-container .remark-content2 {
  max-height: 180px;
  line-height: 1.5;
}
.image-container .remark-container .remark-content .box {
  width: 40px;
  height: 40px;
  background-color: red;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  padding: 0 10px;
  cursor: pointer;
}
.image-container .remark-container .remark-content .box .isShow {
  display: none;
  flex-shrink: 0;
  font-size: 12px;
  margin-right: 20px;
}
.image-container .remark-container .remark-content .box:hover {
  width: auto;
}
.image-container .remark-container .remark-content .box:hover .isShow {
  display: block;
}
.product-item {
  min-height: 100px;
  background-color: #fff;
  width: 100%;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
}
.product-item .title {
  color: #666666;
  line-height: 17px;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 4px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.product-item .price {
  padding: 0 10px;
  font-size: 16px;
  color: #333;
  line-height: 22px;
  font-weight: bold;
  margin-bottom: 12px;
}
.product-item .btn {
  --tw-bg-opacity: 1;
  background-color: rgba(216, 16, 16, var(--tw-bg-opacity));
  text-align: center;
  height: 36px;
  line-height: 36px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}
.product-item .btn:hover {
  background-color: #e04040;
}
.product-item .btn.disable {
  background: #ec8888 !important;
}</style>
